import {BuyingOnlineOfferResponseBody} from '../api/types/BuyingOnlineOfferResponseBody';
import {BusinessCaseOnlineOfferResponseBody} from '../api/types/onlineOfferTypes';

/**
 * Adapts a buying offer payload into the shared offer context so the buying
 * routes can render the very same section tree as the selling routes.
 *
 * The mapping is written out field by field on purpose. Spreading the buying
 * payload would silently leak differently-named fields and, worse, would make
 * it impossible to see which selling-only fields stay `undefined`. Those
 * undefined fields are load bearing: every selling-only section hides itself
 * through its own nil guard, which is how buying reaches layout parity without
 * a bespoke page.
 */
export const toOnlineOfferContext = (
  offer: BuyingOnlineOfferResponseBody
): Partial<BusinessCaseOnlineOfferResponseBody> => ({
  vehicle: offer.vehicle,
  customer: offer.customer,
  owner: offer.owner,
  disclaimer: offer.disclaimer,
  offerValidTo: offer.offerValidTo,
  activeChatConversationId: offer.activeChatConversationId,
  counterpart: offer.counterpart,
  saleVehiclePhotos: offer.photos,
  // A buying offer shows only the car's own photos.
  illustrativePhoto: null,
  vehiclePriceWithVat: offer.purchasePriceWithVat,
  vehiclePriceWithoutVat: offer.purchasePriceWithoutVat,
});
